// Redux Import
import {
  setCallBack,
  setModalState,
  setConfirmText,
  setAlertText,
} from '../store/modules/modal';
import { useDispatch, useSelector } from 'react-redux';

// Type Import
import { ModalState, CallBackFunction } from '../store/modules/modal';

/** 호출양식:
   * onClick은 요청취소, 삭제버튼 등의 onClick
   * testPost는 api 로직
   * onSuccess, onError에서 openAlertModal('취소가 완료되었습니다.'); 호출
   * onClick={() =>
      openConfirmModal('정말 취소하시겠습니까?', 
        () =>
          testPost(item.registrationId)
      )
    }  
    */

/** 확인모달 -> 완료모달로 이어지는 로직 수행하는 Modal Hook */
const useModal = () => {
  const dispatch = useDispatch();

  const callBack = useSelector(
    (state: { modal: { callBack: CallBackFunction } }) => state.modal.callBack
  );

  const modalState = useSelector(
    (state: { modal: { modalState: ModalState } }) => state.modal.modalState
  );

  /** 확인모달 띄워줄 때 호출하는 함수. modal관련 로직의 실행부 */
  const openConfirmModal = (
    message: string,
    callBackProps: CallBackFunction
  ) => {
    if (callBackProps !== null) dispatch(setCallBack(callBackProps));
    dispatch(setConfirmText(message));
    dispatch(setModalState(ModalState.CONFIRM_AWAIT));
  };

  /** api요청 완료시 호출되어야 함 */
  const openAlertModal = (message: string) => {
    dispatch(setAlertText(message));
    dispatch(setModalState(ModalState.ALLERT_NOW));
  };

  /** 각 state별로 서비스로직을 수행 */
  switch (modalState) {
    case ModalState.PROCESS_DONE:
      dispatch(setModalState(ModalState.PROCESS_IDLE));
      dispatch(setConfirmText(''));
      dispatch(setAlertText(''));
      dispatch(setCallBack(null));
      break;

    case ModalState.CONFIRM_ALLOW:
      if (callBack !== null) callBack();
      dispatch(setCallBack(null));
      break;

    default:
      break;
  }

  return {
    openConfirmModal,
    openAlertModal,
  };
};

export default useModal;
